export enum ResultMatchType {
    SCORE = 'SCORE',
    TECH_LOSS = 'TECH_LOSS',
    TIE = 'TIE',
}
